import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

/**
 * Renders trusted, admin-authored markdown (certification module bodies, exam stems —
 * the `*_md` fields) to an HTML string. Bind the result with `[innerHTML]`, which runs
 * Angular's DomSanitizer over it (scripts/handlers stripped) — so this pipe never calls
 * bypassSecurityTrustHtml. Use `| markdown` for block content and `| markdown:true` for
 * a single inline run (no wrapping <p>), e.g. a one-line exam question stem.
 */
@Pipe({ name: 'markdown', standalone: true })
export class MarkdownPipe implements PipeTransform {
  transform(value: string | null | undefined, inline = false): string {
    if (!value) {
      return '';
    }
    return (inline ? marked.parseInline(value) : marked.parse(value)) as string;
  }
}
